import React from 'react';
import { useParams } from 'react-router-dom';
import Navbar from '../components/Navabar';
import Footer from '../components/Footer';
import { FileText, Target, TrendingUp, Users, Zap, Search, BarChart3, ClipboardList, Lightbulb, Eye, Rocket, ArrowRight, Globe, Heart, Shield, BookOpen, Activity, Droplets } from 'lucide-react';

const publicationsData = {
  'rapport-impact-2024': {
    title: 'Rapport d\'Impact 2024',
    category: 'Rapport',
    image: '/publications/publication1.jpg',
    content: [
      {
        title: 'Points clés du rapport 2024',
        icon: <Search className="h-6 w-6" />,
        items: [
          {
            title: 'Résilience face aux crises',
            description: 'Malgré les turbulences économiques et climatiques, l\'Afrique, y compris le Bénin, a montré une capacité d\'adaptation remarquable.',
            icon: <Shield className="h-5 w-5" />
          },
          {
            title: 'Croissance des investissements',
            description: 'Le portefeuille de projets de la BAD a atteint 60 milliards de dollars, avec des financements axés sur l\'énergie, l\'éducation et l\'infrastructure.',
            icon: <TrendingUp className="h-5 w-5" />
          },
          {
            title: 'Accès à l\'électricité',
            description: 'En 2023, 2,4 millions de personnes ont bénéficié de nouveaux raccordements électriques grâce aux initiatives de la BAD.',
            icon: <Zap className="h-5 w-5" />
          },
          {
            title: 'Autonomisation des femmes',
            description: 'Des programmes ont été mis en place pour renforcer les compétences et l\'inclusion économique des femmes.',
            icon: <Heart className="h-5 w-5" />
          },
          {
            title: 'Développement durable',
            description: 'La BAD a poursuivi ses efforts dans les domaines stratégiques des "High 5" :',
            icon: <Globe className="h-5 w-5" />,
            subItems: [
              'Éclairer l\'Afrique et l\'alimenter en énergie',
              'Nourrir l\'Afrique',
              'Industrialiser l\'Afrique',
              'Intégrer l\'Afrique',
              'Améliorer la qualité de vie des populations'
            ]
          }
        ]
      },
      {
        title: 'Que signifie cela pour Action-Humanitaire Bénin ?',
        icon: <Lightbulb className="h-6 w-6" />,
        description: 'Ce rapport montre que les priorités de développement du Bénin sont alignées avec les ODD et les axes stratégiques de la BAD.'
      }
    ]
  },
  'Rapport Annuel 2024': {
    title: 'Rapport Annuel 2023',
    category: 'Rapport Annuel',
    image: '/publications/publication2.jpg',
    content: [
      {
        title: 'Performance économique',
        icon: <BarChart3 className="h-6 w-6" />,
        items: [
          {
            title: 'Croissance du PIB',
            description: 'Le Bénin a enregistré une croissance de 6,2 %, portée par l\'expansion de la zone industrielle de Glo-Djigbé (GDIZ) et les investissements dans les infrastructures.',
            icon: <TrendingUp className="h-5 w-5" />
          },
          {
            title: 'Stabilité budgétaire',
            description: 'Les efforts d\'assainissement budgétaire ont permis de maîtriser les dépenses publiques et d\'améliorer la gestion fiscale.',
            icon: <Shield className="h-5 w-5" />
          },
          {
            title: 'Secteurs clés en progression',
            description: 'Les secteurs suivants ont montré une progression significative :',
            icon: <Activity className="h-5 w-5" />,
            subItems: [
              'Agriculture : Adaptation aux défis climatiques et modernisation des pratiques agricoles.',
              'Industrie : Développement de la transformation locale pour réduire la dépendance aux importations.',
              'Services : Croissance du secteur tertiaire, notamment dans le commerce et les télécommunications.'
            ]
          }
        ]
      },
      {
        title: 'Perspectives économiques',
        icon: <Eye className="h-6 w-6" />,
        items: [
          {
            title: 'Investissements climatiques',
            description: 'Le Bénin doit renforcer ses efforts d\'adaptation pour limiter les pertes économiques dues au changement climatique.',
            icon: <Globe className="h-5 w-5" />
          },
          {
            title: 'Développement des infrastructures',
            description: 'Priorité aux projets de transport et aux réseaux numériques pour améliorer la connectivité.',
            icon: <Zap className="h-5 w-5" />
          },
          {
            title: 'Partenariats avec le secteur privé',
            description: 'Mobilisation des financements pour soutenir la croissance et l\'innovation.',
            icon: <Users className="h-5 w-5" />
          }
        ]
      },
      {
        title: 'Implications pour Action-Humanitaire Bénin',
        icon: <Lightbulb className="h-6 w-6" />,
        description: 'Ces tendances montrent que le Bénin mise sur une croissance durable et résiliente, ce qui ouvre des opportunités pour des projets alignés sur les ODD.'
      }
    ]
  },
  'performance-perspectives': {
    title: 'Performance et Perspectives',
    category: 'Analyse',
    image: '/publications/publication3.jpg',
    content: [
      {
        title: 'Performance économique',
        icon: <BarChart3 className="h-6 w-6" />,
        items: [
          {
            title: 'Croissance du PIB',
            description: 'Le Bénin a enregistré une croissance de 6,2 %, portée par l\'expansion de la zone industrielle de Glo-Djigbé (GDIZ) et les investissements dans les infrastructures.',
            icon: <TrendingUp className="h-5 w-5" />
          },
          {
            title: 'Stabilité budgétaire',
            description: 'Les efforts d\'assainissement budgétaire ont permis de maîtriser les dépenses publiques et d\'améliorer la gestion fiscale.',
            icon: <Shield className="h-5 w-5" />
          },
          {
            title: 'Secteurs clés en progression',
            description: 'Les secteurs suivants ont montré une progression significative :',
            icon: <Activity className="h-5 w-5" />,
            subItems: [
              'Agriculture : Adaptation aux défis climatiques et modernisation des pratiques agricoles.',
              'Industrie : Développement de la transformation locale pour réduire la dépendance aux importations.',
              'Services : Croissance du secteur tertiaire, notamment dans le commerce et les télécommunications.'
            ]
          }
        ]
      },
      {
        title: 'Perspectives économiques',
        icon: <Eye className="h-6 w-6" />,
        items: [
          {
            title: 'Investissements climatiques',
            description: 'Le Bénin doit renforcer ses efforts d\'adaptation pour limiter les pertes économiques dues au changement climatique.',
            icon: <Globe className="h-5 w-5" />
          },
          {
            title: 'Développement des infrastructures',
            description: 'Priorité aux projets de transport et aux réseaux numériques pour améliorer la connectivité.',
            icon: <Zap className="h-5 w-5" />
          },
          {
            title: 'Partenariats avec le secteur privé',
            description: 'Mobilisation des financements pour soutenir la croissance et l\'innovation.',
            icon: <Users className="h-5 w-5" />
          }
        ]
      },
      {
        title: 'Que signifie cela pour Action-Humanitaire Bénin ?',
        icon: <Lightbulb className="h-6 w-6" />,
        description: 'Ces tendances montrent que le Bénin mise sur une croissance durable et résiliente, ce qui ouvre des opportunités pour des projets alignés sur les ODD.'
      }
    ]
  },
  'revue-efficacite-2024': {
    title: 'Revue d\'Efficacité 2024',
    category: 'Revue',
    image: '/publications/publication4.jpg',
    content: [
      {
        title: 'Revue d\'Efficacité des Programmes',
        icon: <ClipboardList className="h-6 w-6" />,
        items: [
          {
            title: 'Accès à l\'eau',
            icon: <Droplets className="h-5 w-5" />,
            subItems: [
              'Construction de 10 forages',
              'Formation de 20 comités de gestion',
              'Maintenance préventive mise en place'
            ]
          },
          {
            title: 'Santé communautaire',
            icon: <Heart className="h-5 w-5" />,
            subItems: [
              '15 campagnes de vaccination réalisées',
              'Formation de 30 agents de santé',
              'Création de 5 centres de soins'
            ]
          },
          {
            title: 'Éducation',
            icon: <BookOpen className="h-5 w-5" />,
            subItems: [
              'Construction de 3 écoles',
              'Formation de 50 enseignants',
              'Distribution de matériel scolaire'
            ]
          }
        ]
      },
      {
        title: 'Analyse d\'Impact',
        icon: <BarChart3 className="h-6 w-6" />,
        items: [
          {
            title: 'Indicateurs clés',
            icon: <Target className="h-5 w-5" />,
            subItems: [
              'Taux de satisfaction des bénéficiaires : 85%',
              'Durabilité des projets : 90%',
              'Efficacité des formations : 75%'
            ]
          }
        ]
      },
      {
        title: 'Améliorations Proposées',
        icon: <Lightbulb className="h-6 w-6" />,
        subItems: [
          'Renforcement du suivi post-projet',
          'Amélioration de la communication',
          'Optimisation des ressources'
        ]
      },
      {
        title: 'Objectifs 2025',
        icon: <Rocket className="h-6 w-6" />,
        subItems: [
          'Expansion dans 10 nouvelles communautés',
          'Développement de 5 nouveaux programmes',
          'Renforcement des partenariats existants'
        ]
      }
    ]
  }
};

const PublicationDetail = () => {
  const { slug } = useParams();
  const publication = publicationsData[slug];

  if (!publication) {
    return (
      <div className="min-h-screen bg-white">
        <Navbar />
        <div className="max-w-4xl mx-auto px-4 py-16 text-center">
          <h1 className="text-2xl text-gray-800">Publication non trouvée</h1>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Enhanced Hero Section */}
      <section className="relative h-[400px] mb-16 overflow-hidden">
        {/* Enhanced Molecular Background Pattern */}
        <div className="absolute inset-0 bg-gradient-to-br from-[#089556] via-[#0b6f47] to-[#07D1EB]">
          <div className="absolute inset-0 opacity-[0.3]">
            <div className="absolute inset-0" style={{
              backgroundImage: `
                radial-gradient(circle at 20% 30%, rgba(255,255,255,0.8) 3px, transparent 3px),
                radial-gradient(circle at 80% 70%, rgba(255,255,255,0.6) 2.5px, transparent 2.5px),
                radial-gradient(circle at 40% 80%, rgba(255,255,255,0.7) 2px, transparent 2px),
                radial-gradient(circle at 70% 20%, rgba(255,255,255,0.5) 3.5px, transparent 3.5px),
                radial-gradient(circle at 90% 50%, rgba(255,255,255,0.8) 2.8px, transparent 2.8px),
                radial-gradient(circle at 30% 60%, rgba(255,255,255,0.6) 2.2px, transparent 2.2px)
              `,
              backgroundSize: '200px 200px, 160px 160px, 220px 220px, 180px 180px, 190px 190px, 150px 150px'
            }}></div>
            
            {/* Enhanced Connection Lines */}
            <div className="absolute inset-0" style={{
              backgroundImage: `
                linear-gradient(35deg, transparent 48%, rgba(255,255,255,0.4) 49%, rgba(255,255,255,0.4) 51%, transparent 52%),
                linear-gradient(-35deg, transparent 48%, rgba(255,255,255,0.3) 49%, rgba(255,255,255,0.3) 51%, transparent 52%),
                linear-gradient(70deg, transparent 48%, rgba(255,255,255,0.35) 49%, rgba(255,255,255,0.35) 51%, transparent 52%)
              `,
              backgroundSize: '350px 350px, 320px 320px, 380px 380px',
              opacity: '0.5'
            }}></div>
          </div>

          {/* Enhanced Floating Molecules */}
          <div className="absolute inset-0 overflow-hidden pointer-events-none">
            <div className="absolute top-1/6 left-1/4 w-5 h-5 bg-white rounded-full opacity-20 animate-pulse shadow-lg shadow-white/40"></div>
            <div className="absolute top-2/3 right-1/4 w-4 h-4 bg-white rounded-full opacity-30 animate-bounce shadow-lg shadow-white/50"></div>
            <div className="absolute top-1/2 left-3/4 w-4.5 h-4.5 bg-white rounded-full opacity-25 animate-pulse shadow-lg shadow-white/45"></div>
            <div className="absolute top-1/4 right-1/3 w-3 h-3 bg-white rounded-full opacity-35 animate-bounce shadow-lg shadow-white/40"></div>
            <div className="absolute bottom-1/6 left-1/6 w-3.5 h-3.5 bg-white rounded-full opacity-25 animate-pulse shadow-lg shadow-white/50"></div>
          </div>
        </div>

        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-center relative z-10">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-white/20 backdrop-blur-sm rounded-full mb-8 shadow-xl border border-white/30">
              <FileText className="h-10 w-10 text-white" />
            </div>
            <h1 className="text-5xl md:text-6xl font-black text-white tracking-tight drop-shadow-lg mb-4">
              {publication.title}
            </h1>
            <div className="inline-flex items-center gap-3 bg-white/20 backdrop-blur-sm px-6 py-2 rounded-full shadow-lg border border-white/30">
              <span className="text-white font-medium">{publication.category}</span>
            </div>
            <div className="w-32 h-1 bg-white/60 mx-auto mt-6 rounded-full"></div>
          </div>
        </div>
      </section>

      <main className="max-w-7xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
        {/* Enhanced Publication Content Section */}
        <section className="relative mb-20 overflow-hidden">
          {/* Molecular Background */}
          <div className="absolute inset-0 opacity-[0.08]">
            <div className="absolute inset-0" style={{
              backgroundImage: `
                radial-gradient(circle at 25% 25%, #089556 2px, transparent 2px),
                radial-gradient(circle at 75% 75%, #07D1EB 1.5px, transparent 1.5px),
                radial-gradient(circle at 50% 10%, #089556 1px, transparent 1px)
              `,
              backgroundSize: '150px 150px, 120px 120px, 180px 180px'
            }}></div>
          </div>

          <div className="relative z-10">
            {/* Publication Image */}
            <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-8 shadow-xl border border-white/20 mb-8">
              <div className="flex justify-center">
                <img 
                  src={publication.image}
                  alt={publication.title}
                  className="w-full h-auto max-w-4xl object-cover rounded-xl shadow-lg"
                />
              </div>
            </div>

            {/* Publication Content */}
            <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-8 shadow-xl border border-white/20">
              <div className="flex items-center gap-6 mb-8">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-[#089556] to-[#07D1EB] rounded-full shadow-lg">
                  <FileText className="h-8 w-8 text-white" />
                </div>
                <div>
                  <h2 className="text-3xl font-bold text-[#089556]">Contenu de la Publication</h2>
                  <div className="w-20 h-1 bg-gradient-to-r from-[#089556] to-[#07D1EB] rounded-full mt-2"></div>
                </div>
              </div>

              <div className="space-y-12">
                {publication.content.map((section, index) => (
                  <div key={index} className="bg-gradient-to-r from-[#089556]/5 to-[#07D1EB]/5 p-8 rounded-2xl border border-white/20">
                    <div className="flex items-center gap-4 mb-6">
                      <div className="inline-flex items-center justify-center w-12 h-12 bg-gradient-to-br from-[#089556] to-[#07D1EB] rounded-full shadow-lg">
                        {section.icon}
                      </div>
                      <h3 className="text-2xl font-semibold text-[#089556]">{section.title}</h3>
                    </div>

                    {section.description && (
                      <p className="text-gray-700 mb-6 leading-relaxed text-lg text-justify">
                        {section.description}
                      </p>
                    )}

                    {section.items && (
                      <div className="space-y-6">
                        {section.items.map((item, itemIndex) => (
                          <div key={itemIndex} className="bg-white/80 backdrop-blur-sm p-6 rounded-xl border border-white/20">
                            <div className="flex items-start gap-4 mb-3">
                              <div className="inline-flex items-center justify-center w-10 h-10 bg-gradient-to-br from-[#089556] to-[#07D1EB] rounded-full shadow-md flex-shrink-0">
                                {item.icon}
                              </div>
                              <h4 className="text-xl font-semibold text-[#089556] mt-1">{item.title}</h4>
                            </div>
                            
                            {item.description && (
                              <p className="text-gray-700 mb-4 leading-relaxed text-justify ml-14">
                                {item.description}
                              </p>
                            )}

                            {item.subItems && (
                              <ul className="space-y-2 ml-14">
                                {item.subItems.map((subItem, subIndex) => (
                                  <li key={subIndex} className="flex items-start gap-3">
                                    <div className="w-2 h-2 bg-[#07D1EB] rounded-full mt-2 flex-shrink-0"></div>
                                    <span className="text-gray-600 text-justify">{subItem}</span>
                                  </li>
                                ))}
                              </ul>
                            )}
                          </div>
                        ))}
                      </div>
                    )}

                    {section.subItems && !section.items && (
                      <ul className="space-y-3">
                        {section.subItems.map((subItem, subIndex) => (
                          <li key={subIndex} className="flex items-start gap-3">
                            <div className="w-2 h-2 bg-[#07D1EB] rounded-full mt-2 flex-shrink-0"></div>
                            <span className="text-gray-600 text-justify">{subItem}</span>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Enhanced Related Publications Section */}
        <section className="relative mb-20 overflow-hidden">
          {/* Molecular Background */}
          <div className="absolute inset-0 opacity-[0.06]">
            <div className="absolute inset-0" style={{
              backgroundImage: `
                radial-gradient(circle at 30% 70%, #089556 2px, transparent 2px),
                radial-gradient(circle at 70% 30%, #07D1EB 1.5px, transparent 1.5px)
              `,
              backgroundSize: '170px 170px, 140px 140px'
            }}></div>
          </div>

          <div className="relative z-10">
            <div className="flex items-center gap-6 mb-12">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-[#089556] to-[#07D1EB] rounded-full shadow-lg">
                <TrendingUp className="h-8 w-8 text-white" />
              </div>
              <div>
                <h2 className="text-4xl font-bold text-[#089556]">Publications Similaires</h2>
                <div className="w-24 h-1 bg-gradient-to-r from-[#089556] to-[#07D1EB] rounded-full mt-2"></div>
              </div>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {Object.entries(publicationsData).filter(([key]) => key !== slug).slice(0, 3).map(([key, pub]) => (
                <div key={key} className="group relative bg-white/90 backdrop-blur-sm rounded-2xl shadow-lg p-6 border border-white/20 hover:shadow-xl transition-all duration-300 hover:scale-105">
                  <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-[#089556] to-[#07D1EB] rounded-t-2xl"></div>
                  
                  <div className="text-[#089556] mb-4 mt-2">
                    <FileText className="h-8 w-8" />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-800 mb-3">{pub.title}</h3>
                  <div className="inline-flex items-center gap-2 bg-gradient-to-r from-[#089556]/10 to-[#07D1EB]/10 px-3 py-1 rounded-full text-sm text-[#089556] font-medium">
                    {pub.category}
                  </div>

                  {/* Decorative Elements */}
                  <div className="absolute top-4 right-4 w-8 h-8 opacity-10">
                    <div className="w-2 h-2 bg-[#07D1EB] rounded-full absolute top-0 left-0 animate-pulse"></div>
                    <div className="w-1.5 h-1.5 bg-[#089556] rounded-full absolute top-2 right-0 animate-pulse" style={{animationDelay: '0.5s'}}></div>
                  </div>

                  {/* Hover Arrow */}
                  <div className="absolute bottom-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <ArrowRight className="h-5 w-5 text-[#089556]" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default PublicationDetail;
